import { defineStore } from 'pinia'

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    cameFromUsers: false,
  }),
  actions: {
    setCameFromUsers(value) {
      this.cameFromUsers = value
    },
  },
})